import React from 'react';
import { Modal, Button, Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useAuth } from '../../hooks/useAuth';

const Profile = ({ isVisible, onClose }) => {
  const { user } = useAuth();

  return (
    <Modal
      title="User Profile"
      visible={isVisible}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      <div className="flex flex-col items-center">
        <Avatar
          size={64}
          icon={<UserOutlined />}
          src={user?.picture}
          alt="User avatar"
          className="mb-4"
        />
        <h2 className="text-xl font-semibold">{user?.username || 'Username'}</h2>
        <p className="text-gray-500">{user?.email || 'user@example.com'}</p>
        {/* Add more user info fields as needed */}
        <div className="mt-4 w-full">
          <div className="flex justify-between mb-2">
            <span className="font-medium">Full Name:</span>
            <span>{user?.fullName || 'Full Name'}</span>
          </div>
          <div className="flex justify-between mb-2">
            <span className="font-medium">Role:</span>
            <span>{user?.role || 'User Role'}</span>
          </div>
          <div className="flex justify-between mb-2">
            <span className="font-medium">Member Since:</span>
            <span>{user?.memberSince || 'Join Date'}</span>
          </div>
          {/* Add more fields as necessary */}
        </div>
      </div>
    </Modal>
  );
};

export default Profile;
